export const NONE_ROLE = 'None';
